import React, { ChangeEvent, ClipboardEvent, FC, RefObject, useEffect, useRef, useState } from 'react';
import { Alert, Box, Grid } from '@mui/material';
import { ValidationItem } from '@components/ValidatePhone/ValidationItem';
import { ReportProblem } from '@mui/icons-material';
interface ValidationCodeProps {
  onCodeComplete(code: string): void;
  error?: boolean;
  errorMessage?: string | null;
}
export const ValidationCode: FC<ValidationCodeProps> = ({ onCodeComplete, errorMessage, error }) => {
  const code1Ref = useRef<HTMLInputElement>(null);
  const code2Ref = useRef<HTMLInputElement>(null);
  const code3Ref = useRef<HTMLInputElement>(null);
  const code4Ref = useRef<HTMLInputElement>(null);
  const code5Ref = useRef<HTMLInputElement>(null);
  const code6Ref = useRef<HTMLInputElement>(null);
  const refs = [code1Ref, code2Ref, code3Ref, code4Ref, code5Ref, code6Ref];
  const [code, setCode] = useState(['', '', '', '', '', '']);

  const updateCodeAt = (index: number, value: string) => {
    const updated = [...code];
    updated[index] = value;
    setCode(updated);
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    next: RefObject<HTMLInputElement | null> | null
  ) => {
    const value = e.target.value;
    updateCodeAt(index, value.slice(-1)); // only keep the last digit

    if (value.length === 1 && next?.current) {
      next.current.focus();
    }
  };

  useEffect(() => {
    if (code.every((c) => Boolean(c))) {
      const fullCode = code.join('');

      onCodeComplete(fullCode);
    }
  }, [code]);

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const paste = e.clipboardData?.getData('text').trim() || '';
    if (!/^\d{2,}$/.test(paste)) return; // skip if not digits

    e.preventDefault(); // prevent default paste

    const chars = paste.split('');
    for (let i = 0; i < refs.length; i++) {
      const input = refs[i].current;
      if (input && chars[i]) {
        input.value = chars[i];
      }
    }
    setCode(chars);

    // Focus the next empty input
    const nextIndex = Math.min(chars.length, refs.length - 1);
    refs[nextIndex].current?.focus();
  };
  // 123456
  return (
    <>
      {error && (
        <Box mr={4} ml={4}>
          <Alert
            icon={<ReportProblem />}
            sx={{ fontFamily: 'Roboto', color: '#EB3223', fontSize: 13 }}
            severity="error"
          >
            {errorMessage}
          </Alert>
        </Box>
      )}
      <Grid marginLeft={4} marginRight={4} padding={2} container flexDirection={'row'} gap={4} flexWrap={'nowrap'}>
        {refs.map((ref, i) => (
          <Grid key={i}>
            <ValidationItem
              error={error}
              inputRef={ref}
              onPaste={i === 0 ? handlePaste : undefined}
              onChange={(e) => handleChange(e, i, refs[i + 1] || null)}
            ></ValidationItem>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
